// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3574":"096c3394","6497":"096c3394"}[chunkId] + ".chunk.css";
};